export function getSlideId(){var id=window.tnsId;window.tnsId=!id?1:id+1;return'tns'+window.tnsId;}